import { render, staticRenderFns } from "./subcategoryForm.vue?vue&type=template&id=aea2ac76&"
import script from "./subcategoryForm.vue?vue&type=script&lang=js&"
export * from "./subcategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports